// Файл use_authorization_viewport.js

/**
 * Модуль обслуживает сценарий `use_authorization_viewport` в разделе
 * `page_authorization`.
 * Он содержит обработчики и данные, относящиеся к этой части клиентского
 * интерфейса.
 * Код связывает локальную логику с соседними компонентами без
 * дублирования общих правил.
 * Такое разделение упрощает сопровождение, проверку поведения и
 * дальнейшее расширение.
 */

import { useEffect } from 'react';



const use_authorization_viewport = () => {
    useEffect(() => {
        const root = document.documentElement;
        const visual_viewport = window.visualViewport;
        let maximum_portrait_height = 0;

        const update_viewport = () => {
            const viewport_height = Math.round(
                visual_viewport?.height || window.innerHeight
            );
            const is_portrait = window.innerWidth <= window.innerHeight;

            if (is_portrait && viewport_height > maximum_portrait_height) {
                maximum_portrait_height = viewport_height;
            }

            const is_compact = is_portrait && (
                viewport_height <= 720
                || viewport_height < maximum_portrait_height * 0.88
            );
            const is_keyboard_open = is_portrait && (
                maximum_portrait_height > 0
                && viewport_height < maximum_portrait_height * 0.72
            );

            root.style.setProperty(
                '--authorization-viewport-height',
                `${viewport_height}px`
            );
            root.classList.toggle(
                'authorization-portrait',
                is_portrait,
            );
            root.classList.toggle(
                'authorization-compact',
                is_compact,
            );
            root.classList.toggle(
                'authorization-keyboard-open',
                is_keyboard_open,
            );
        };

        update_viewport();
        window.addEventListener('resize', update_viewport);
        window.addEventListener('orientationchange', update_viewport);
        window.screen?.orientation?.addEventListener(
            'change',
            update_viewport,
        );
        visual_viewport?.addEventListener(
            'resize',
            update_viewport
        );
        visual_viewport?.addEventListener(
            'scroll',
            update_viewport
        );

        return () => {
            window.removeEventListener('resize', update_viewport);
            window.removeEventListener(
                'orientationchange',
                update_viewport
            );
            window.screen?.orientation?.removeEventListener(
                'change',
                update_viewport,
            );
            visual_viewport?.removeEventListener(
                'resize',
                update_viewport
            );
            visual_viewport?.removeEventListener(
                'scroll',
                update_viewport
            );
            root.style.removeProperty(
                '--authorization-viewport-height'
            );
            root.classList.remove(
                'authorization-portrait',
                'authorization-compact',
                'authorization-keyboard-open',
            );
        };
    }, []);
};


export { use_authorization_viewport };
